import React from 'react';
import { getDefaultClientCompanyRoleModel } from './models';
import DetailedSelectOption from '../../../components/shared/DetailedSelectOption';
import Label from '../../../components/shared/Label';
export const getClientRelatedData = (clientCompaniesRoles, clientId) => clientCompaniesRoles.find(x => x.clientId === clientId) || getDefaultClientCompanyRoleModel();
const getAvailableUsersMessage = (usersNo) => usersNo === 1 ?
    'USER.MESSAGE.AVAILABLE_USER' : 'USER.MESSAGE.AVAILABLE_USERS';
export const getUserClientOption = (clientName, availableUsersNo, currentAssociations = [], clientId) => {
    const availableUsersMessage = clientName === '' ? '' : getAvailableUsersMessage(availableUsersNo);
    const hasOtherAssociationForClient = currentAssociations.some(x => x.clientId === clientId);
    return {
        value: clientId !== null && clientId !== void 0 ? clientId : clientName,
        renderOption: (<DetailedSelectOption name={clientName} details={<Label title={availableUsersMessage} titleRelatedData={{ availableUsersNo }}/>}/>),
        disabled: availableUsersNo === 0 && !hasOtherAssociationForClient
    };
};
